import React, { useContext, useState } from 'react';
import { Button } from '@indigo-ag/component-module';
import { ContractStatus } from '@indigo-ag/schema';

import i18next from 'core/i18n';
import { CollateralFormalizationContext } from '../../../CollateralAnalysis/CollateralFormalization/CollateralFormalization';
import { DecisionModal } from 'features/brazil-grower/components/BrazilGrowerFinance/shared/DecisionModal/DecisionModal';
import { utils } from 'shared';

interface AmendmentSignatureRequestProps {
  disabled?: boolean;
}

type SignatureType = 'digital' | 'physical';

export const AmendmentSignatureRequest: React.FunctionComponent<AmendmentSignatureRequestProps> = ({
  disabled = false
}) => {
  /**
   * State
   */
  const [isRequestSignatureModalOpen, setIsRequestSignatureModalOpen] = useState(false);
  const [signatureType, setSignatureType] = useState<SignatureType>();

  /**
   * Context
   */
  const { updatePhase3 } = useContext(CollateralFormalizationContext);

  const openRequestSignatureModal = (signatureType: SignatureType) => {
    return () => {
      setSignatureType(signatureType);
      setIsRequestSignatureModalOpen(true);
    };
  };

  const closeRequestSignatureModal = () => {
    setIsRequestSignatureModalOpen(false);
    setSignatureType(undefined);
  };

  const confirmDecision = (decisionNotes: string) =>
    updatePhase3({
      contractStatus:
        signatureType === 'digital'
          ? ContractStatus.WAITING_DIGITAL_SIGNATURE
          : ContractStatus.WAITING_PHYSICAL_SIGNATURE,
      amendmentSignatureRequestedNotes: decisionNotes
    });

  return (
    <div className="flex justify-flex-end mt-4">
      <Button
        size="small"
        className="text-transform-capitalize"
        disabled={disabled}
        onClick={openRequestSignatureModal('digital')}
      >
        {i18next.t('digitalSignature')}
      </Button>
      <Button
        size="small"
        className="text-transform-capitalize"
        disabled={disabled}
        onClick={openRequestSignatureModal('physical')}
      >
        {i18next.t('physicalSignature')}
      </Button>
      <DecisionModal
        open={isRequestSignatureModalOpen}
        title={i18next.t(signatureType === 'digital' ? 'requestingDigitalSignature' : 'requestingPhysicalSignature')}
        message={utils.text.firstLetterUppercase(
          i18next.t(
            signatureType === 'digital' ? 'requestingDigitalSignatureMessage' : 'requestingPhysicalSignatureMessage'
          )
        )}
        closeModal={closeRequestSignatureModal}
        onConfirmAction={confirmDecision}
      />
    </div>
  );
};
